import {isProduction} from '../util';

export function getMediaCardImageSrc(path: string) {
  if (isProduction()) {
    return `https://cdn.mxpnl.com/user-media/dashboards/${path}`;
  }
  return `https://cdn-dev.mxpnl.com/user-media/dashboards/${path}`;
}
